import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import { APP_URL } from '../config';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;

  const logo = (
    <Box sx={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1080.000000 1080.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)"
        >
          <path
            d="M3800 9155 c-203 -32 -376 -126 -521 -283 -73 -80 -116 -147 -165
-260 -65 -151 -64 -127 -64 -1245 0 -959 1 -1014 19 -1052 22 -48 70 -97 120
-122 32 -16 74 -18 403 -21 281 -2 369 -6 377 -16 6 -7 24 -53 40 -103 59
-181 177 -394 289 -522 l38 -43 55 35 c69 44 157 88 237 117 34 12 62 24 62
26 0 2 -13 37 -30 79 -71 180 -121 396 -140 615 -5 63 -10 121 -10 128 0 9
-70 12 -317 12 -191 0 -333 4 -356 11 -49 13 -105 63 -128 114 -17 37 -19 83
-19 700 0 638 1 663 21 735 53 191 187 340 371 414 37 14 93 28 125 31 88 7
720 14 1473 17 461 2 593 4 415 8 -143 3 -241 7 -217 8 23 1 42 4 42 7 0 13
-39 48 -68 62 -19 9 -38 26 -42 39 -5 13 -18 29 -30 36 -11 7 -20 18 -20 25 0
7 -4 13 -9 13 -18 0 -71 62 -71 82 0 11 -11 29 -25 40 -14 11 -24 25 -23 32 2
6 -23 38 -55 70 -31 32 -57 67 -57 77 0 10 -6 19 -12 20 -44 2 -62 12 -64 32
0 7 -2 20 -2 30 -1 11 -10 17 -27 17 -14 0 -25 5 -25 11 0 6 -13 8 -30 5 -17
-2 -28 0 -24 5 3 5 60 10 127 11 77 1 29 4 -128 8 -467 13 -1441 9 -1535 -5z"
          />
          <path
            d="M5125 8160 c-3 -5 -12 -7 -19 -4 -21 8 -241 -68 -337 -117 -121 -60
-329 -205 -329 -228 1 -24 290 -168 303 -150 2 2 25 42 52 88 85 147 210 300
313 385 24 20 39 36 34 36 -6 0 -13 -4 -17 -10z m-71 -45 c3 -10 -1 -15 -11
-15 -9 0 -13 -3 -10 -7 8 -7 -21 -43 -35 -43 -5 0 -6 4 -3 10 3 5 -3 15 -15
22 -27 17 -25 24 8 36 40 15 59 14 66 -3z"
          />
          <path
            d="M4980 8100 c0 -5 5 -10 10 -10 6 0 10 5 10 10 0 6 -4 10 -10 10 -5 0
-10 -4 -10 -10z"
          />
          <path d="M5820 8156 c0 -2 7 -9 15 -16 13 -11 14 -10 9 4 -5 14 -24 23 -24 12z" />
          <path
            d="M5353 8135 c-94 -40 -244 -174 -338 -300 -43 -58 -135 -208 -135
-220 0 -2 42 -13 93 -24 100 -22 202 -36 340 -47 l87 -6 0 306 c0 168 -3 306
-7 306 -5 -1 -22 -7 -40 -15z"
          />
          <path
            d="M5560 7845 l0 -304 73 6 c39 2 99 9 132 15 33 5 93 13 134 18 40 5
76 11 78 13 9 9 -50 17 -60 9 -7 -5 -33 -12 -58 -15 l-45 -6 4 59 c3 43 1 60
-8 60 -8 0 -11 10 -8 30 3 20 0 30 -9 30 -8 0 -13 12 -13 31 0 17 4 28 10 24
6 -3 10 1 10 9 0 9 -9 16 -20 16 -11 0 -20 7 -20 15 0 8 5 15 10 15 6 0 10 -5
10 -11 0 -5 5 -7 11 -3 8 5 6 10 -7 18 -18 11 -28 30 -25 51 1 6 2 22 4 37 1
14 6 30 11 35 5 5 6 2 1 -6 -6 -10 -4 -12 4 -6 9 5 6 14 -11 32 -25 28 -147
109 -184 123 l-24 10 0 -305z"
          />
          <path
            d="M5940 8046 c0 -2 8 -10 18 -17 15 -13 16 -12 3 4 -13 16 -21 21 -21
13z"
          />
          <path d="M5767 7936 c-4 -10 -1 -13 8 -9 8 3 12 9 9 14 -7 12 -11 11 -17 -5z" />
          <path
            d="M5840 7936 c14 -18 13 -19 -2 -13 -15 5 -16 4 -5 -13 6 -11 17 -18
23 -16 13 5 34 -13 34 -28 0 -6 -7 -3 -14 7 -12 15 -15 15 -26 3 -18 -23 -4
-37 26 -26 14 6 31 7 37 3 17 -10 -48 71 -70 88 -17 13 -17 13 -3 -5z"
          />
          <path
            d="M4289 7662 c-66 -76 -157 -218 -214 -337 -78 -161 -123 -320 -148
-522 l-4 -33 293 0 292 0 7 63 c26 256 63 419 139 621 14 38 25 70 24 71 -2 2
-43 20 -92 40 -48 21 -126 62 -172 91 l-84 52 -41 -46z"
          />
          <path
            d="M5990 7698 c0 -4 4 -8 9 -8 6 0 12 4 15 8 3 5 -1 9 -9 9 -8 0 -15 -4
-15 -9z"
          />
          <path
            d="M4782 7393 c-61 -167 -97 -340 -117 -555 l-6 -68 231 0 c159 0 230 3
230 11 0 6 18 36 40 67 44 63 121 122 190 145 l45 15 3 195 2 194 -107 7
c-114 8 -290 36 -383 61 -93 25 -92 26 -128 -72z"
          />
          <path d="M5948 7433 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z" />
          <path d="M5898 7423 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path
            d="M5818 7415 c-3 -3 -61 -9 -129 -13 l-124 -7 -3 -189 c-3 -195 -1
-205 37 -206 11 0 9 4 -5 16 -16 13 -16 15 -2 10 10 -3 20 -1 23 4 3 5 20 7
38 5 24 -4 26 -3 9 3 l-24 7 21 27 c12 14 21 31 21 37 0 6 7 11 15 11 8 0 23
18 32 40 10 22 21 40 25 40 5 0 8 9 8 19 0 11 14 31 30 44 17 14 30 35 30 46
0 10 6 22 13 24 10 4 10 6 0 6 -20 1 -15 29 6 36 12 3 18 12 15 20 -3 7 2 15
13 18 11 3 5 5 -13 6 -17 0 -33 -1 -36 -4z m2 -25 c-14 -4 -41 -8 -60 -8 l-35
1 40 7 c57 10 87 10 55 0z"
          />
          <path d="M5868 7363 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z" />
          <path
            d="M5660 6975 c0 -2 10 -10 23 -16 20 -11 21 -11 8 4 -13 16 -31 23 -31
12z"
          />
          <path
            d="M5385 6778 c-68 -37 -114 -132 -100 -201 23 -103 89 -160 188 -161
73 -1 124 25 162 83 28 43 41 116 25 151 l-10 25 5 -27 c5 -24 2 -27 -25 -26
-19 1 -29 6 -27 12 3 8 -6 10 -27 8 -31 -4 -41 2 -110 64 -15 14 -29 36 -30
49 0 15 -5 20 -10 14 -16 -15 -30 -10 -16 6 15 18 3 19 -25 3z"
          />
          <path
            d="M4666 6491 c-3 -5 -1 -67 4 -137 16 -207 51 -372 116 -552 l35 -100
37 9 c124 30 238 50 340 60 64 6 136 13 160 15 l42 5 0 208 0 208 -47 18
c-110 40 -195 121 -233 224 l-18 46 -215 3 c-123 1 -218 -2 -221 -7z"
          />
          <path d="M6442 6390 c0 -14 2 -19 5 -12 2 6 2 18 0 25 -3 6 -5 1 -5 -13z" />
          <path d="M6253 6335 c0 -22 2 -30 4 -17 2 12 2 30 0 40 -3 9 -5 -1 -4 -23z" />
          <path d="M5740 6295 c-11 -13 -10 -14 4 -9 9 3 16 10 16 15 0 13 -6 11 -20 -6z" />
          <path d="M6243 6245 c0 -27 2 -38 4 -22 2 15 2 37 0 50 -2 12 -4 0 -4 -28z" />
          <path d="M6431 6254 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path
            d="M6959 6233 c0 -10 -3 -13 -6 -5 -2 6 -9 9 -14 6 -6 -3 -5 -11 2 -20
9 -11 7 -14 -13 -14 -13 0 -29 5 -36 12 -9 9 -12 7 -12 -10 0 -19 -5 -22 -40
-22 -22 0 -40 -4 -40 -10 0 -5 -18 -10 -40 -10 -27 0 -40 -4 -40 -14 0 -14
-78 -26 -166 -26 -23 0 -44 -5 -46 -11 -2 -6 -16 -12 -31 -12 -15 -1 -27 -6
-28 -12 -1 -5 -5 1 -9 15 -8 24 -8 24 -9 3 -1 -13 -5 -23 -10 -23 -4 0 -7 12
-5 28 2 15 -14 -36 -35 -113 -22 -77 -56 -183 -75 -234 -19 -52 -34 -96 -33
-96 1 -1 29 -12 62 -25 72 -28 196 -91 247 -125 l36 -24 55 67 c117 144 193
282 257 472 24 69 47 131 53 138 6 7 38 13 81 14 56 1 61 2 23 5 -27 3 -45 8
-42 14 4 5 2 8 -4 7 -5 -2 -16 4 -23 13 -7 10 -23 20 -35 24 -18 5 -23 2 -24
-12z m46 -13 c3 -5 1 -10 -4 -10 -6 0 -11 5 -11 10 0 6 2 10 4 10 3 0 8 -4 11
-10z m0 -28 c-11 -2 -25 -9 -32 -14 -8 -7 -11 -4 -10 9 1 15 7 18 31 14 23 -4
26 -6 11 -9z m-51 -47 c-4 -8 -8 -15 -10 -15 -2 0 -4 7 -4 15 0 8 4 15 10 15
5 0 7 -7 4 -15z m-67 -37 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z
m-403 -43 c-4 -8 -7 -15 -9 -15 -2 0 -5 7 -9 15 -3 9 0 15 9 15 9 0 12 -6 9
-15z m443 -17 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z"
          />
          <path d="M6424 6196 c-3 -8 -4 -25 -2 -38 3 -17 5 -13 9 15 5 38 2 47 -7 23z" />
          <path
            d="M5562 5979 l-2 -187 93 -7 c117 -9 265 -30 380 -55 50 -11 92 -18 94
-17 12 13 66 193 87 295 25 120 34 190 15 124 -7 -23 -15 -32 -24 -28 -8 3
-16 -3 -19 -12 -3 -9 -3 3 -1 28 2 25 2 36 -1 25 -9 -32 -26 -44 -22 -15 3 25
2 25 -79 28 -65 2 -83 0 -83 -11 0 -15 -158 -37 -262 -37 -31 0 -59 -4 -63 -9
-3 -6 -20 -17 -37 -26 -25 -12 -33 -13 -40 -3 -4 8 -8 -4 -8 -29 0 -78 -19
-44 -23 40 -1 45 -4 -2 -5 -104z m650 71 l-9 -24 -5 22 c-4 12 -2 20 3 16 5
-3 9 0 9 7 0 7 2 10 5 7 3 -3 2 -16 -3 -28z"
          />
          <path
            d="M7280 5671 c0 -377 -7 -438 -68 -559 -86 -173 -236 -295 -416 -337
-94 -22 -2531 -22 -2625 0 -178 42 -326 161 -409 330 -57 115 -65 154 -70 368
l-4 197 -319 0 -319 0 0 -399 c0 -439 3 -472 61 -622 55 -144 191 -319 314
-407 114 -81 258 -142 385 -161 56 -9 502 -11 1725 -9 l1650 3 88 28 c242 75
429 232 540 452 40 81 86 220 57 175 -8 -13 -10 -12 -10 3 0 11 -4 15 -12 11
-8 -5 -9 2 -5 25 7 36 -27 111 -50 111 -8 0 -13 15 -13 40 0 22 -4 40 -10 40
-5 0 -10 9 -10 19 0 11 -13 31 -30 44 -23 20 -30 34 -30 61 0 35 -1 36 -40 36
-39 0 -40 0 -40 38 -1 33 -7 42 -52 76 -28 22 -46 42 -40 44 22 7 -11 42 -40
42 -18 0 -28 5 -28 14 0 8 -21 33 -47 55 l-48 41 -6 -38 c-3 -21 -7 17 -8 86
-1 115 -2 122 -21 122 -19 0 -20 -7 -20 -117 0 -215 -8 -111 -15 202 -4 171
-9 312 -11 314 -2 2 -4 -145 -4 -328z m60 -191 c0 -22 -4 -40 -10 -40 -5 0
-10 18 -10 40 0 22 5 40 10 40 6 0 10 -18 10 -40z"
          />
          <path
            d="M5310 5643 c-136 -9 -413 -53 -427 -67 -2 -2 12 -31 31 -65 121 -213
285 -390 434 -465 l52 -26 0 315 0 315 -22 -2 c-13 -1 -43 -3 -68 -5z"
          />
          <path
            d="M5560 5329 l0 -311 48 28 c108 63 233 179 324 302 48 64 128 201 128
218 0 23 -307 74 -442 74 l-58 0 0 -311z"
          />
          <path
            d="M4655 5504 c-90 -35 -215 -102 -215 -115 0 -11 115 -100 195 -151 91
-59 177 -102 276 -138 68 -25 224 -70 243 -70 4 0 -24 27 -62 59 -105 90 -214
226 -297 369 -26 45 -48 82 -49 82 0 -1 -41 -17 -91 -36z"
          />
          <path
            d="M6146 5431 c-76 -128 -183 -259 -275 -339 -40 -35 -65 -62 -55 -58
11 3 50 12 88 21 133 30 335 123 461 213 74 53 145 113 145 122 0 19 -254 140
-293 140 -6 0 -38 -44 -71 -99z"
          />
          <path d="M7904 4970 c0 -63 1 -89 3 -57 2 31 2 83 0 115 -2 31 -3 5 -3 -58z" />
          <path d="M7891 4824 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path d="M7881 4764 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path
            d="M950 3085 l0 -446 93 3 92 3 2 295 c1 162 2 299 3 303 0 5 118 -129
261 -297 l262 -306 93 0 94 0 0 445 0 445 -90 0 -90 0 0 -127 c0 -261 -5 -473
-12 -470 -3 1 -120 135 -260 297 l-254 295 -97 3 -97 3 0 -446z"
          />
          <path d="M2030 3085 l0 -445 90 0 90 0 0 445 0 445 -90 0 -90 0 0 -445z" />
          <path
            d="M2390 3085 l0 -445 328 0 c383 0 410 4 478 75 82 85 88 266 12 347
l-29 31 20 21 c35 37 51 91 51 169 0 124 -58 207 -165 236 -25 7 -165 11 -367
11 l-328 0 0 -445z m651 246 c19 -15 24 -29 24 -66 0 -39 -5 -51 -28 -71 -27
-23 -33 -24 -202 -24 -162 0 -175 -1 -185 -19 -14 -27 -13 -114 2 -129 8 -8
65 -12 189 -12 163 0 178 -2 203 -21 22 -18 26 -28 26 -74 0 -46 -4 -56 -26
-74 -25 -19 -40 -21 -202 -21 l-176 0 -43 -42 -43 -42 0 307 0 307 219 0 c201
0 221 -2 242 -19z"
          />
          <path
            d="M3415 3518 c-3 -7 -4 -206 -3 -443 l3 -430 93 -3 92 -3 0 152 c0 140
1 151 18 143 9 -4 80 -10 156 -13 l139 -6 40 -65 c22 -36 61 -98 85 -137 l45
-73 104 0 c57 0 103 3 103 6 0 3 -38 65 -85 139 -47 73 -85 137 -85 143 0 5
14 15 30 22 43 18 95 82 111 138 22 73 17 236 -8 293 -27 62 -87 116 -147 134
-67 20 -684 22 -691 3z m641 -192 c24 -20 28 -33 32 -88 4 -65 -11 -116 -40
-135 -7 -4 -89 -10 -183 -13 l-170 -5 -32 -49 c-65 -100 -63 -103 -63 117 l0
197 214 0 c212 0 215 0 242 -24z"
          />
          <path
            d="M4766 3483 c-13 -27 -88 -187 -166 -358 -78 -170 -160 -348 -181
-393 -22 -46 -39 -86 -39 -88 0 -3 46 -3 102 -2 l101 3 111 240 c62 132 127
275 146 318 18 42 37 77 40 77 5 0 116 -231 137 -287 4 -9 -23 -13 -109 -15
l-113 -3 -3 -42 c-2 -22 4 -57 12 -77 l15 -36 139 0 138 0 34 -77 c18 -43 38
-84 43 -90 6 -9 40 -13 103 -13 77 0 94 3 94 15 0 13 -158 365 -338 752 l-57
123 -92 0 -93 0 -24 -47z"
          />
          <path
            d="M5624 3516 c-104 -33 -154 -111 -154 -241 0 -133 33 -195 128 -242
56 -28 61 -28 267 -31 197 -3 211 -5 233 -24 34 -32 32 -109 -4 -137 -26 -20
-38 -21 -325 -21 l-299 0 0 -90 0 -90 313 0 c341 0 377 4 443 55 44 33 72 89
80 158 17 141 -27 241 -126 289 -53 25 -63 27 -262 31 -125 3 -215 10 -228 17
-41 22 -52 93 -21 131 l19 24 299 5 298 5 3 88 3 87 -313 -1 c-224 0 -325 -4
-354 -13z"
          />
          <path
            d="M7345 3341 c-3 -6 5 -15 17 -21 21 -10 21 -10 6 3 -10 8 -15 17 -11
20 3 4 4 7 0 7 -3 0 -8 -4 -12 -9z"
          />
          <path
            d="M8712 2980 l-2 -335 90 3 90 3 0 158 c0 87 -3 206 -7 265 -6 100 -7
105 -19 77 -12 -29 -44 -44 -44 -20 0 6 -7 8 -17 5 -9 -4 -20 -1 -25 6 -6 11
-10 10 -17 -1 -7 -11 -9 -11 -14 0 -4 10 -6 10 -6 2 -1 -7 -5 -13 -11 -13 -5
0 -11 42 -13 93 -1 50 -4 -59 -5 -243z"
          />
          <path
            d="M9347 3297 c-3 -8 1 -14 8 -14 7 0 11 6 8 14 -3 7 -6 13 -8 13 -2 0
-5 -6 -8 -13z"
          />
          <path
            d="M6782 2977 l-2 -328 293 3 c264 3 296 5 332 22 68 33 96 57 132 113
44 69 63 157 63 296 l0 108 -31 -16 c-24 -13 -34 -14 -45 -4 -7 6 -11 15 -8
20 3 5 0 9 -5 9 -6 0 -11 -9 -11 -19 0 -17 -4 -18 -35 -9 -22 7 -35 18 -38 32
-2 12 -5 -40 -6 -114 -1 -119 -4 -141 -23 -180 -40 -77 -58 -85 -224 -88
l-144 -3 -33 -44 c-17 -24 -35 -44 -39 -45 -5 0 -8 110 -8 245 0 164 -3 245
-10 245 -6 0 -10 -6 -9 -12 3 -28 -1 -49 -10 -44 -5 4 -12 0 -14 -6 -3 -7 -6
1 -7 17 -1 28 -2 29 -10 8 -6 -15 -18 -23 -32 -23 -19 0 -20 2 -8 10 9 6 10
10 3 10 -6 0 -15 -5 -18 -11 -4 -6 -13 -8 -21 -5 -10 4 -15 -4 -16 -27 -1 -18
-5 13 -8 68 -4 62 -7 -25 -8 -228z"
          />
          <path d="M8041 3264 c0 -11 3 -14 6 -6 3 7 2 16 -1 19 -3 4 -6 -2 -5 -13z" />
          <path
            d="M9326 3248 c-9 -12 -16 -26 -16 -31 0 -5 -24 -59 -54 -120 -67 -140
-107 -225 -162 -349 l-43 -98 98 0 98 0 21 48 c11 26 41 94 67 152 26 58 60
135 75 171 l27 65 -21 36 c-24 41 -18 58 12 33 12 -11 18 -26 15 -39 -2 -11 5
-4 17 17 28 51 20 74 -24 69 -23 -3 -38 -12 -47 -28 -14 -27 -29 -32 -29 -9 0
8 -4 15 -9 15 -5 0 -7 -10 -5 -22 4 -21 4 -21 -8 -6 -11 16 -14 15 -31 -10
-10 -15 -16 -20 -13 -12 2 8 12 39 21 67 9 29 21 52 27 50 6 -1 13 4 15 11 8
20 -15 13 -31 -10z m94 -153 c0 -16 -43 -14 -46 3 -1 7 0 8 3 2 10 -20 24 -10
17 12 -6 20 -5 21 10 9 9 -7 16 -19 16 -26z"
          />
          <path
            d="M7841 3219 c-10 -24 -55 -123 -98 -219 -116 -254 -153 -337 -153
-344 0 -3 43 -6 95 -6 82 0 97 2 102 18 3 9 41 95 84 190 69 152 78 179 75
220 -6 68 -13 81 -43 76 -14 -3 -32 1 -40 7 -11 10 -15 8 -19 -9 -4 -11 -12
-23 -19 -26 -14 -5 23 66 37 72 4 2 8 8 8 13 0 6 -4 7 -10 4 -14 -9 -13 8 2
23 6 6 9 15 5 18 -4 4 -15 -13 -26 -37z m89 -89 c0 -5 -4 -10 -10 -10 -5 0
-10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z"
          />
          <path
            d="M8100 3255 c0 -5 5 -17 10 -25 5 -8 10 -10 10 -5 0 6 -5 17 -10 25
-5 8 -10 11 -10 5z"
          />
          <path d="M9576 3237 c3 -10 9 -15 12 -12 3 3 0 11 -7 18 -10 9 -11 8 -5 -6z" />
          <path d="M7887 3233 c-4 -3 -7 -13 -7 -22 1 -13 3 -13 11 2 11 19 8 33 -4 20z" />
          <path d="M9346 3215 c-9 -26 -7 -32 5 -12 6 10 9 21 6 23 -2 3 -7 -2 -11 -11z" />
          <path
            d="M8286 3204 c-5 -14 3 -33 24 -54 3 -3 5 -12 5 -20 0 -8 5 -14 12 -13
6 1 13 -3 16 -11 3 -7 -1 -13 -9 -13 -8 0 -14 4 -14 9 0 4 -18 8 -39 8 -36 0
-39 2 -34 23 3 12 2 19 -2 15 -5 -5 -8 -25 -8 -45 0 -21 -2 -29 -4 -19 -4 15
-7 16 -15 5 -7 -10 -8 -8 -3 9 8 26 2 28 -21 5 -16 -16 -16 -16 -10 5 5 16 3
24 -9 28 -28 11 -26 -1 9 -78 19 -42 32 -79 29 -82 -4 -3 -55 -6 -114 -6 -59
0 -110 -4 -113 -9 -8 -12 13 -112 26 -128 8 -9 49 -13 143 -13 l132 0 38 -85
38 -85 99 0 c54 0 97 3 95 8 -3 4 -57 122 -121 262 -65 140 -122 257 -128 261
-6 4 -8 11 -4 17 3 6 2 13 -3 16 -5 3 -12 -1 -15 -10z"
          />
          <path d="M9480 3204 c0 -8 5 -12 10 -9 6 4 8 11 5 16 -9 14 -15 11 -15 -7z" />
          <path
            d="M9763 3192 c0 -18 4 -28 7 -21 4 6 14 -8 23 -34 12 -37 13 -46 2 -51
-7 -2 -15 4 -18 15 -3 12 -1 17 6 12 7 -4 8 0 4 11 -4 10 -7 20 -7 24 0 3 -6
-3 -14 -14 -13 -16 -18 -17 -35 -6 -28 16 -42 15 -35 -3 4 -8 1 -15 -5 -15 -6
0 -10 3 -9 8 0 4 -4 18 -11 32 -11 25 -11 25 -6 -5 l5 -30 -15 25 c-9 16 -14
19 -15 10 0 -9 7 -26 16 -38 9 -13 14 -26 11 -29 -9 -9 -39 59 -34 77 3 14 1
17 -11 13 -11 -5 -14 -2 -9 11 4 10 3 15 -3 11 -6 -3 -10 -1 -10 6 0 7 -2 10
-5 7 -3 -3 12 -45 34 -94 22 -49 43 -101 46 -116 l7 -28 -111 0 c-91 0 -113
-3 -118 -15 -6 -17 14 -103 30 -122 7 -9 48 -13 141 -13 l132 0 35 -82 35 -83
97 -3 c53 -1 97 0 97 4 0 8 -134 308 -204 457 -43 93 -53 106 -53 79z m-86
-154 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z"
          />
          <path
            d="M7965 3170 c-8 -24 -8 -24 -17 -5 -5 13 -6 8 -2 -15 4 -19 7 -47 7
-62 0 -16 1 -28 3 -28 7 0 55 113 50 118 -3 3 -9 -4 -13 -14 -6 -17 -8 -16
-13 6 l-6 25 -9 -25z"
          />
          <path
            d="M8250 3175 c0 -8 7 -15 15 -15 9 0 12 6 9 15 -4 8 -10 15 -15 15 -5
0 -9 -7 -9 -15z"
          />
          <path
            d="M2928 2255 c-31 -17 -52 -71 -42 -109 14 -57 93 -85 143 -50 31 22
12 43 -23 25 -34 -19 -74 -6 -87 26 -22 57 36 111 85 80 34 -22 48 -1 16 25
-27 21 -55 22 -92 3z"
          />
          <path
            d="M3188 2255 c-58 -32 -67 -107 -17 -149 35 -29 67 -33 108 -11 33 17
41 33 41 84 0 66 -74 109 -132 76z m80 -31 c45 -31 19 -114 -36 -114 -56 0
-83 69 -42 110 24 24 48 25 78 4z"
          />
          <path
            d="M4254 2260 c-32 -13 -54 -50 -54 -88 0 -72 100 -122 145 -72 23 25
12 37 -19 21 -33 -18 -68 -10 -85 20 -33 59 22 120 80 87 19 -11 31 -13 35 -6
17 27 -61 56 -102 38z"
          />
          <path
            d="M5148 2255 c-31 -17 -52 -71 -42 -109 22 -88 164 -87 164 0 0 35 -1
35 -37 32 -40 -3 -48 -21 -13 -26 34 -6 20 -36 -17 -40 -38 -4 -73 26 -73 62
0 30 47 70 72 62 10 -3 27 -9 38 -12 30 -9 25 20 -5 34 -33 15 -54 15 -87 -3z"
          />
          <path
            d="M5820 2263 c-25 -10 -52 -37 -61 -62 -12 -31 6 -86 34 -106 86 -60
194 60 125 139 -23 26 -70 40 -98 29z m70 -43 c24 -24 26 -57 4 -88 -18 -26
-65 -30 -88 -6 -35 35 -5 114 44 114 11 0 29 -9 40 -20z"
          />
          <path
            d="M6718 2253 c-55 -34 -60 -102 -13 -149 72 -71 193 26 145 117 -12 22
-61 49 -87 49 -10 0 -30 -8 -45 -17z m92 -33 c39 -39 14 -110 -40 -110 -38 0
-60 24 -60 65 0 57 60 85 100 45z"
          />
          <path
            d="M7453 2254 c-42 -21 -58 -72 -38 -120 25 -62 97 -74 146 -25 45 46
35 117 -20 146 -37 19 -48 19 -88 -1z m81 -30 c52 -52 12 -128 -59 -110 -27 7
-46 52 -34 83 15 40 65 55 93 27z"
          />
          <path
            d="M3430 2169 c0 -68 3 -90 13 -87 7 3 14 29 17 64 l5 59 45 -62 c25
-34 51 -63 58 -63 9 0 12 25 12 90 0 73 -3 90 -15 90 -12 0 -15 -14 -15 -62
l0 -62 -46 62 c-64 87 -74 83 -74 -29z"
          />
          <path
            d="M3700 2170 c0 -72 3 -90 15 -90 10 0 15 16 17 62 l3 63 45 -62 c25
-34 51 -63 58 -63 9 0 12 25 12 90 0 73 -3 90 -15 90 -12 0 -15 -13 -15 -61
l0 -61 -45 61 c-64 87 -75 82 -75 -29z"
          />
          <path
            d="M3970 2170 l0 -90 65 0 c51 0 65 3 65 15 0 11 -12 15 -50 15 -47 0
-50 2 -50 25 0 23 4 25 45 25 33 0 45 4 45 15 0 11 -12 15 -46 15 -41 0 -45 2
-42 23 3 19 10 22 51 25 71 5 57 22 -18 22 l-65 0 0 -90z"
          />
          <path
            d="M4450 2251 c0 -5 12 -11 28 -13 27 -3 27 -4 30 -80 2 -60 6 -78 17
-78 12 0 15 17 15 80 l0 80 30 0 c17 0 30 5 30 10 0 6 -32 10 -75 10 -41 0
-75 -4 -75 -9z"
          />
          <path
            d="M4700 2170 c0 -73 3 -90 15 -90 12 0 15 17 15 90 0 73 -3 90 -15 90
-12 0 -15 -17 -15 -90z"
          />
          <path
            d="M4842 2173 c2 -56 7 -88 15 -90 8 -3 13 16 15 62 l3 67 48 -66 c67
-91 77 -88 77 24 0 72 -3 90 -15 90 -10 0 -15 -16 -17 -62 l-3 -63 -44 63
c-28 39 -51 62 -63 62 -17 0 -19 -7 -16 -87z"
          />
          <path
            d="M5545 2208 c25 -37 35 -64 35 -90 0 -27 4 -38 15 -38 11 0 15 11 15
41 0 29 9 53 30 84 34 50 36 55 15 55 -9 0 -25 -16 -36 -35 -23 -39 -32 -38
-54 6 -9 17 -24 29 -36 29 -18 0 -16 -5 16 -52z"
          />
          <path
            d="M6042 2191 c2 -50 9 -75 22 -90 23 -25 72 -28 104 -5 19 13 22 24 22
90 0 58 -3 74 -15 74 -11 0 -15 -17 -17 -72 -3 -73 -3 -73 -33 -76 -40 -5 -55
19 -55 90 0 47 -3 58 -16 58 -14 0 -16 -11 -12 -69z"
          />
          <path
            d="M6440 2250 c0 -5 14 -10 30 -10 l30 0 0 -80 c0 -63 3 -80 15 -80 11
0 15 18 17 78 3 76 3 77 31 80 57 7 24 22 -48 22 -43 0 -75 -4 -75 -10z"
          />
          <path
            d="M7110 2170 c0 -70 3 -90 14 -90 19 0 25 19 20 74 -4 54 5 53 31 -4
10 -22 24 -40 32 -40 7 0 23 21 36 46 l22 47 5 -58 c3 -34 10 -60 18 -63 9 -3
12 19 12 87 0 81 -2 91 -18 91 -12 0 -28 -20 -47 -57 l-28 -58 -26 58 c-20 45
-30 57 -48 57 -22 0 -23 -3 -23 -90z"
          />
          <path
            d="M7690 2170 c0 -73 3 -90 15 -90 10 0 15 11 15 35 0 30 3 35 23 35 14
0 30 -12 45 -35 21 -34 42 -46 42 -25 0 6 -7 22 -16 36 -15 23 -15 26 0 43 19
21 21 62 4 79 -7 7 -38 12 -70 12 l-58 0 0 -90z m98 61 c8 -5 12 -17 10 -27
-2 -14 -13 -20 -41 -22 -33 -3 -37 -1 -37 21 0 13 3 27 7 30 9 10 45 8 61 -2z"
          />
          <path
            d="M7940 2170 l0 -90 65 0 c51 0 65 3 65 15 0 11 -12 15 -50 15 -46 0
-50 2 -50 24 0 22 5 25 42 28 59 4 63 28 4 28 -38 0 -46 3 -46 19 0 20 25 31
73 31 15 0 27 5 27 10 0 6 -28 10 -65 10 l-65 0 0 -90z"
          />
          <path
            d="M957 2194 c-3 -3 -3 -12 0 -20 4 -12 131 -14 829 -14 817 0 824 0
824 20 0 20 -7 20 -823 20 -453 0 -826 -3 -830 -6z"
          />
          <path
            d="M8357 2193 c-4 -3 -7 -12 -7 -20 0 -11 146 -13 835 -13 828 0 835 0
835 20 0 20 -7 20 -828 20 -456 0 -832 -3 -835 -7z"
          />
        </g>
      </svg>
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  // Render as external link
  return (
    <a
      href={APP_URL}
      target="_blank"
      rel="noopener noreferrer"
      style={{ display: 'block', width: '100%', height: '100%' }}
    >
      {logo}
    </a>
  );
}
